import AlertCountLinks from "./components/alert_count_links/alert_count_links";
import WebpackerReact from 'webpacker-react'

WebpackerReact.setup({AlertCountLinks});